export default __webpack_public_path__ + "static/media/cards.02fbaca2.svg";